// src/helpers/rehypeStripReservedProps.ts

/**
 * Rehype plugin that removes the `ref` and `key` attributes from every element.
 *
 * rehype-raw turns model-written HTML into real elements, and React treats
 * `ref` and `key` as its own props rather than attributes. A string `ref` makes
 * React throw ("Function components cannot have string refs", error #290 in
 * production), and the nearest error boundary is the root one, so one stray
 * attribute - e.g. a model writing <doc-cite ref="t1-c2" /> instead of
 * data-ref - takes down the whole task pane. Neither attribute means anything
 * in rendered markdown.
 *
 * Must run after rehype-raw: before it, model HTML is still raw nodes.
 */

type HastNode = {
  type: string;
  properties?: Record<string, unknown>;
  children?: HastNode[];
};

const stripReservedProps = (node: HastNode): void => {
  if (node.type === "element" && node.properties) {
    delete node.properties.ref;
    delete node.properties.key;
  }

  node.children?.forEach(stripReservedProps);
};

export const rehypeStripReservedProps = () => (tree: HastNode) => {
  stripReservedProps(tree);
};

export default rehypeStripReservedProps;
